export const DEFAULT_ERROR_MESSAGE = 'Houve um erro inesperado, tente novamente mais tarde.'

export const INVALID_EMAIL = 'Email inválido.'

export const DEFAULT_SEND_CODE_ERROR_MESSAGE = 'Houve um erro ao enviar o código de confirmação.'

export const DEFAULT_CONFIRM_ERROR_MESSAGE = 'Houve um erro ao confirmar o código.'

export const PHONE_SIZE_ERROR_MESSAGE = 'É necessário preencher o telefone corretamente.'
